<template>
    <button class="db-table-action db-btn-outline sm default primary transparent">
        <i class="lab lab-line-pages"></i>
        <span class="db-tooltip">{{ $t('button.clone') }}</span>
    </button>
</template>

<script>
export default {
    name: "SmIconCloneComponent"
}
</script>

<style scoped>

</style>
